export class EmailNotVerifiedError extends Error {

  code?: string = 'auth/email-not-verified';
}
